<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{'Advantage search'|translate}}</div>
    <div slot="body">
      <form v-on:submit.prevent="ok" class="search-form">
        <v-collapse-group :onlyOneActive="true">
          <v-collapse-wrapper>
            <div class="header" v-collapse-toggle>
              {{'Central Location'|translate}}
              <span class="pull-right">{{search_params.address}}</span>
            </div>
            <div class="my-content" v-collapse-content>
              <address-control @changeAddress="changeAddress" :initaddress="searchparams"></address-control>
            </div>
          </v-collapse-wrapper>
          <v-collapse-wrapper>
            <div class="header" v-collapse-toggle>
              {{'Distance(km)'|translate}}
              <span class="pull-right">{{getDistName}}</span>
            </div>
            <div class="my-content" v-collapse-content>
              <div class="content">
                <div class="radio" v-for="(dist) in list_dists" :key="dist.id">
                  <label>
                    <input type="radio" v-bind:value="dist.id" v-model="search_params.dist" />
                    {{dist.text|translate}}
                  </label>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
        </v-collapse-group>
        <hr />

        <div class="button-group mt10">
          <button class="mt10 btn btn-primary" type="submit">
            <i v-if="working" class="fas fa-spinner fa-spin"></i>
            {{'OK'|translate}}
          </button>
        </div>
      </form>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import AddressControl from "@/components/elements/AddressControl";
import Utils from "@/helpers/utils";
// import VueGoogleAutocomplete from "vue-google-autocomplete";

import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "advantagesearch",
  components: {
    mymodal,
    // VueGoogleAutocomplete,
    // GoogleAutocomplete
    AddressControl
  },
  props: ["searchparams"],
  data() {
    return this.initData();
  },
  created() {
    // clone from original params
  },

  computed: {
    getDistName() {
      if (parseInt(this.search_params.dist) === 0) {
        return this.$t("Everywhere");
      } else {
        return this.search_params.dist + " KM";
      }
    }
  },
  methods: {
    initData() {
      return {
        working: false,
        search_params: {
          address: "",
          dist: 0,
          lat: null,
          lng: null
        },
        list_dists: [
          { id: 5, text: "5 KM" },
          { id: 15, text: "15 KM" },
          { id: 25, text: "25 KM" },
          { id: 50, text: "50 KM" },
          { id: 100, text: "100 KM" },
          { id: 0, text: "Everywhere" }
        ]
      };
    },
    changeAddress(data) {
      for (let key in data) {
        this.search_params[key] = data[key];
      }
    },
    open() {
      this.$refs.theModal.open();

      for (let key in this.searchparams) {
        this.search_params[key] = this.searchparams[key];
      }
    },
    ok() {
      if (
        !this.search_params.address &&
        document.getElementById("txtAutocomplete")
      ) {
        // get location from tempaddress
        this.working = true;
        let tempAddress = document.getElementById("txtAutocomplete").value;
        Utils.latlngFromAddress(tempAddress).then(results => {
          this.working = false;
          if (results.length > 0) {
            let location = results[0].geometry.location;
            this.search_params.lat = location.lat();
            this.search_params.lng = location.lng();
            this.search_params.address = tempAddress;
            this.$refs.theModal.close();
            this.$emit("updatedAdvantageSearch", this.search_params);
          } else {
            this.working = false;
            this.$alertify.warning(this.$t("Unable to search your location"));
          }
        });
      } else {
        this.working = false;
        this.$refs.theModal.close();
        this.$emit("updatedAdvantageSearch", this.search_params);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/elements/AdvantageSearch.vue